/* AMB Bundles theme JS */
(function(){
  function money(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/,''); }

  /* ── Accordions (event delegation — works before DOMContentLoaded) ── */
  document.addEventListener('click', function(e){
    var q = e.target.closest('.amb-acc__q, .amb-faq__q');
    if(q) q.parentElement.classList.toggle('open');
  });

  /* ── Quantity steppers ── */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-qty]');
    if(!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value)||1) + parseInt(b.getAttribute('data-qty')));
  });

  /* ── Variant picker + add to cart ── */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var data = JSON.parse(form.querySelector('[data-variant-json]').textContent);
    var idInput = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');

    function update(){
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function(g){
        var c = g.querySelector('input:checked');
        opts[parseInt(g.getAttribute('data-option-index'))] = c ? c.value : null;
      });
      form.querySelectorAll('.amb-pill').forEach(function(p){
        p.setAttribute('aria-checked', p.querySelector('input').checked ? 'true' : 'false');
      });
      var m = data.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); });
      if(!m) return;
      idInput.value = m.id;
      if(priceEl) priceEl.textContent = money(m.price);
      if(addBtn){ addBtn.disabled = !m.available; addBtn.textContent = m.available ? (addBtn.getAttribute('data-add-text') + ' \u00b7 ' + money(m.price)) : 'Sold out'; }
    }
    form.querySelectorAll('.amb-pill input').forEach(function(i){ i.addEventListener('change', update); });
    update();

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var qty = parseInt((form.querySelector('[name=quantity]')||{}).value || 1);
      var orig = addBtn.textContent; addBtn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: idInput.value, quantity: qty }) })
        .then(function(r){ return r.json(); })
        .then(function(){ addBtn.textContent = orig; openCart(); refreshCart(); })
        .catch(function(){ addBtn.textContent = orig; });
    });
  });

  /* ── Cart drawer ── */
  var overlay, drawer;
  function openCart(){ if(drawer){ drawer.classList.add('open'); overlay.classList.add('open'); } }
  function closeCart(){ if(drawer){ drawer.classList.remove('open'); overlay.classList.remove('open'); } }
  window.openCart = openCart;

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var count = document.querySelector('[data-cart-count]'); if(count) count.textContent = cart.item_count;
      var sub = document.querySelector('[data-cart-subtotal]'); if(sub) sub.textContent = money(cart.total_price);
      var body = document.querySelector('[data-cart-items]'); var empty = document.querySelector('[data-cart-empty]');
      if(!body) return;
      if(cart.items.length === 0){ if(empty) empty.style.display='block'; body.innerHTML=''; return; }
      if(empty) empty.style.display='none';
      body.innerHTML = cart.items.map(function(it){
        var img = it.image ? '<img src="'+it.image+'" alt="">' : '';
        return '<div class="amb-citem"><div class="amb-citem__img">'+img+'</div><div style="flex:1"><div style="display:flex;justify-content:space-between;gap:8px"><span style="font-size:15px;color:var(--dark);font-weight:500">'+it.product_title+'</span><span style="font-size:15px;color:var(--accent-ink);font-weight:500">'+money(it.final_line_price)+'</span></div><div style="font-size:12px;color:#9a857d;margin:3px 0 8px">'+(it.variant_title||'')+' \u00b7 Qty '+it.quantity+'</div><span data-remove="'+it.key+'" style="cursor:pointer;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#c2a59d">Remove</span></div></div>';
      }).join('');
    });
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-toggle]')){ e.preventDefault(); openCart(); refreshCart(); }
    if(e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) closeCart();
    var rm = e.target.closest('[data-remove]');
    if(rm){ fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity:0 }) }).then(function(r){return r.json();}).then(refreshCart); }
  });

  /* ── Collection filter chips ── */
  document.querySelectorAll('[data-filter]').forEach(function(chip){
    chip.addEventListener('click', function(){
      var val = chip.getAttribute('data-filter');
      document.querySelectorAll('[data-filter]').forEach(function(c){ c.classList.toggle('is-active', c===chip); });
      if(val === 'all'){
        document.querySelectorAll('[data-group]').forEach(function(g){ g.style.display = ''; });
      } else {
        document.querySelectorAll('[data-group]').forEach(function(g){
          g.style.display = (g.getAttribute('data-group') === val) ? '' : 'none';
        });
      }
    });
  });

  /* ── Mobile menu ── */
  (function(){
    var toggle = document.getElementById('amb-mnav');
    if(!toggle) return;
    var burger = document.querySelector('.amb-burger');
    var panel = document.getElementById('amb-mnav-panel');
    function sync(){ if(burger){ burger.setAttribute('aria-expanded', toggle.checked ? 'true' : 'false'); burger.setAttribute('aria-label', toggle.checked ? 'Close menu' : 'Open menu'); } }
    toggle.addEventListener('change', sync);
    if(panel) panel.addEventListener('click', function(e){ if(e.target.closest('a')){ toggle.checked = false; sync(); } });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && toggle.checked){ toggle.checked = false; sync(); } });
    sync();
  })();

  /* ══════════════════════════════════════════════════
     Everything below requires the DOM to be complete
     (DOMContentLoaded fires after this script runs
     since it's at the end of <body>)
  ══════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function(){

    /* Cart drawer refs */
    overlay = document.querySelector('[data-cart-overlay]');
    drawer  = document.querySelector('[data-cart-drawer]');
    refreshCart();

    /* ── Product page gallery ── */
    var gallery = document.querySelector('[data-gallery]');
    if(gallery){
      var slides   = Array.prototype.slice.call(gallery.querySelectorAll('.amb-gallery__slide'));
      var thumbs   = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
      var dots     = Array.prototype.slice.call(gallery.querySelectorAll('[data-dot]'));
      var prevBtn  = gallery.querySelector('[data-gallery-prev]');
      var nextBtn  = gallery.querySelector('[data-gallery-next]');
      var mainEl   = gallery.querySelector('[data-gallery-main]');
      var current  = 0;

      function galleryGoTo(n){
        /* Remove active from everything */
        slides[current].classList.remove('is-active');
        if(thumbs[current]) thumbs[current].classList.remove('is-active');
        if(dots[current])   dots[current].classList.remove('is-active');
        /* Wrap index */
        current = ((n % slides.length) + slides.length) % slides.length;
        /* Apply active */
        slides[current].classList.add('is-active');
        if(thumbs[current]) thumbs[current].classList.add('is-active');
        if(dots[current])   dots[current].classList.add('is-active');
      }

      /* Thumbnail clicks */
      thumbs.forEach(function(th){
        th.addEventListener('click', function(){
          galleryGoTo(parseInt(th.getAttribute('data-gallery-thumb'), 10));
        });
      });

      /* Dot clicks */
      dots.forEach(function(dot){
        dot.addEventListener('click', function(){
          galleryGoTo(parseInt(dot.getAttribute('data-dot'), 10));
        });
      });

      /* Arrow buttons */
      if(prevBtn) prevBtn.addEventListener('click', function(){ galleryGoTo(current - 1); });
      if(nextBtn) nextBtn.addEventListener('click', function(){ galleryGoTo(current + 1); });

      /* Touch swipe on main image */
      if(mainEl){
        var swipeX = 0;
        mainEl.addEventListener('touchstart', function(e){ swipeX = e.touches[0].clientX; }, { passive: true });
        mainEl.addEventListener('touchend',   function(e){
          var dx = e.changedTouches[0].clientX - swipeX;
          if(Math.abs(dx) > 44) galleryGoTo(dx < 0 ? current + 1 : current - 1);
        }, { passive: true });
      }
    }

    /* ── Product card image cycling (homepage / collection grids) ── */
    var isTouchDevice = window.matchMedia('(hover:none)').matches;

    document.querySelectorAll('[data-img-cycle]').forEach(function(el){
      var imgs = Array.prototype.slice.call(el.querySelectorAll('.amb-pcard__img'));
      if(imgs.length < 2) return; /* nothing to cycle */

      var idx   = 0;
      var timer = null;

      function cardGoTo(i){
        imgs[idx].classList.remove('is-active');
        idx = ((i % imgs.length) + imgs.length) % imgs.length;
        imgs[idx].classList.add('is-active');
      }

      if(isTouchDevice){
        /* Tap to advance on mobile */
        el.addEventListener('touchend', function(){
          cardGoTo(idx + 1);
        }, { passive: true });
      } else {
        /* Auto-cycle while hovering on desktop */
        el.addEventListener('mouseenter', function(){
          if(timer) return;
          timer = setInterval(function(){ cardGoTo(idx + 1); }, 850);
        });
        el.addEventListener('mouseleave', function(){
          clearInterval(timer);
          timer = null;
          /* Reset to first image */
          imgs[idx].classList.remove('is-active');
          idx = 0;
          imgs[0].classList.add('is-active');
        });
      }
    });

  }); /* end DOMContentLoaded */

})();
